import axios from "axios";
import { toast } from "react-toastify";
import tokenService from "./tokenService";

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  const originalRequest = error.config;
  // catch attempts
  if (error.response.status === 401) {

    originalRequest._retry = true;
    const token = tokenService.getAccessToken();
    const refreshToken = tokenService.getRefreshToken();
    console.log(tokenService.isTokenValid(refreshToken))
    console.log(tokenService.isTokenValid(token))
    
    if (token && tokenService.isTokenValid(refreshToken)) {
      tokenService.refreshToken({refreshToken: refreshToken});
    }
    else
      window.location = "/login";
  }
    else {
      toast(" You need to log in to do that!");
      window.location = "/login";
    }

  // error: no response from server
  if (!expectedError) {
    toast("An unexpected error has occured.");
  }

  return Promise.reject(error);
});

axios.interceptors.request.use(
  (config) => {
    const accessToken = tokenService.getAccessToken();
    if (accessToken) config.headers.common["x-auth-token"] = accessToken;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
};
